export default __webpack_public_path__ + "static/media/profile-frenchy.1545a5e8.png";